import React, {Component} from 'react'
import {Rect} from 'react-konva'
import {KonvaEventObject} from 'konva/lib/Node'
import {RectElement as RectElementData} from '../../../views/LabelBuilder/LabelBuilder.slice'

interface Props {
    element: RectElementData
    onClick: (event: KonvaEventObject<MouseEvent>) => void
    onTransform: (event: KonvaEventObject<MouseEvent>) => void
    onDrag: (event: KonvaEventObject<DragEvent>) => void
    onRightClick: (event: KonvaEventObject<PointerEvent>) => void
    draggable?: boolean
}

export default class RectElement extends Component<Props> {
    render() {
        const {element, draggable = true} = this.props
        return (
            <Rect
                opacity={element.opacity}
                width={element.width}
                height={element.height}
                fill={element.fill}
                strokeWidth={element.strokeWidth}
                strokeScaleEnabled={false}
                id={element.id}
                key={element.id}
                draggable={draggable}
                stroke={element.stroke}
                x={element.x}
                y={element.y}
                scaleX={element.scaleX}
                scaleY={element.scaleY}
                rotation={element.rotation}
                onClick={this.props.onClick}
                onTransform={this.props.onTransform}
                onDragEnd={this.props.onDrag}
                onContextMenu={this.props.onRightClick}/>
        )
    }
}
